import { styled } from "@mui/material";
import {
  TextField as MuiTextField,
  TextFieldProps as MuiTextFieldProps,
} from "@mui/material";

export type TextFieldProps = MuiTextFieldProps & { warning?: boolean };

/**
 * MUI TextField wrapper that filters out the `warning` prop
 * to prevent it from being passed to the DOM element.
 */
export const TextField = styled(MuiTextField, {
  shouldForwardProp: (prop) => prop !== "warning",
})<TextFieldProps>(({ theme, warning, error }) => ({
  ...(warning &&
    !error && {
      [`& .MuiOutlinedInput-root fieldset.MuiOutlinedInput-notchedOutline,
        & .MuiOutlinedInput-root:hover fieldset.MuiOutlinedInput-notchedOutline,
        & .MuiOutlinedInput-root.Mui-focused fieldset.MuiOutlinedInput-notchedOutline`]:
        {
          borderColor: theme.palette.custom.iconWarning,
        },
      "& .MuiOutlinedInput-root:hover": {
        backgroundColor: theme.palette.custom.surfaceWarning,
      },
    }),
}));
